import React from 'react';

const Star = (props) => {
    const { children, parentId, id, value, checked } = props;
    return <>
        <input id={id} type="radio" value={value} name={parentId} checked={checked} />
        <label htmlFor={id}>{children}</label>
    </>;
};

export default Star;
